import { useState, useRef } from 'react';
import { useSpring, animated } from "react-spring";
import './ScrollDown.scss';
import downArrow from './down-arrow.svg';
export default () => {
  const [key, setKey] = useState(1);
  const scrolling = useSpring({
    to: { transform: "translateY(5px)" },
    from: { transform: "translateY(-5px)" },
    config: {
      duration: 1500
    },
    onRest: () => {
      setKey(key + 1);
    },
    reverse: key % 2 === 0
  });

  return (
    <div className="scroll-down"><span>Scroll Down</span><animated.img style={scrolling}src={downArrow} /></div>
  )
}